import * as React from 'react';
export const starSvg = React.forwardRef(function starSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'm13.108 3.64.55-1.64.549 1.639h1.778l-1.438 1.013.549 1.705-1.438-1.079-1.438 1.08.549-1.706L11.33 3.64h1.778Zm-2.82.013a31.02 31.02 0 0 0-5.448.523c-3.852.712-4.84 2-4.84 2h3.556l.06-.099c.313-.52.636-1.059 2.318-1.615 1.79-.592 5.072-.653 5.072-.653v-.143s-.257-.014-.718-.013ZM2.01 6.716h.08c.158 0 .525.016.95.123h4.546s-.094.336-.084.795c0 0-.663-.214-1.6-.05v4.304H4.63V7.563s-.558-.082-1.494.01c0 0-.484-.316-1.042-.316s-.958.163-.958.642c0 .423.556.648 1.02.835l.18.073c.484.204 1.315.582 1.315 1.53 0 .949-.894 1.663-2.178 1.663C.43 12 0 11.674 0 11.674s.179-.49.263-.949l.242-.03s.095.764.99.764c.894 0 1.02-.479 1.02-.775 0-.295-.453-.612-1.168-.867C.63 9.562.063 9.124.063 8.267c0-.857.768-1.55 1.947-1.55Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14.085 6.839h.009c.15-.002 1.352.02 1.352 1.101 0 0 .127 1.194-1.2 1.418 0 0 .93 1.51 1.754 2.53h-1.641l-1.406-2.295v2.295h-2.877l-.581-1.52H7.802l-.693 1.52h-.905l2.441-5.05h.937l1.978 4.869V6.839h2.525Zm.015 1.244c0-.66-.625-.756-.977-.757-.138-.001-.233.013-.233.013v1.713c.789 0 1.21-.122 1.21-.969ZM9.28 9.807l-.557-1.459-.665 1.46H9.28Z',
    }),
  );
});
starSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var star = {
  category: 'paymentmethod',
  colorable: true,
  name: 'star',
  svg: starSvg,
};
